import { useQuery } from '@tanstack/react-query';

import PriceParrotService from '~/services/PriceParrotService';

import { competitorOffersQueryKeys } from './competitorOffersQueryKeys';

export function useGetCompetitorHotelOpportunities(from: string, to: string) {
  return useQuery({
    queryKey: competitorOffersQueryKeys.opportunities(from, to),
    queryFn: async ({ signal }) => (await PriceParrotService.getCompetitorHotelOpportunities(from, to, signal)).data,
  });
}
